module.exports = __webpack_public_path__ + "img/close.1e80fd73.svg";